<template>
  <div id="contenedor-insumos-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'InsumosMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
